import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import SparkApi from "../../api/SparkApi";
import jwtDecode from "jwt-decode";

const Sidebar = () => {
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const location = useLocation();
  const [activeModule, setActiveModule] = useState();
  
  useEffect(() => {
    decodeToken();
  }, []);

  useEffect(() => {
    setActiveModule(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (userInfo?.userrole) {
      fetchModuleData(userInfo.id);
    }
  }, [userInfo]); // Run only after userRole is set

  const decodeToken = () => {
    const token = sessionStorage.getItem("token");
    try {
      if (token) {
        const decoded = jwtDecode(token);
        setUserInfo(decoded);
      }
    } catch (error) {
      console.error("Invalid token", error);
    }
  };

  async function fetchModuleData(id) {
    try {
      const data = await SparkApi.fetchModules(id);
      if(Array.isArray(data.result)){
        let sortedModules = [...data.result].sort(
          (a, b) => a.order_no - b.order_no
        );
        
        if (userInfo.userrole === "USER") {
          sortedModules = sortedModules.filter(
            (module) => module.url !== "/users"
          );
        }
        
        setModules(sortedModules);
      }
    } catch (error) {
      setModules([]);
    }
  }

  const navigatePage = (destination) => {
    if (isMobile) hideSideBar();
    setTimeout(() => {
      setActiveModule(destination);
      navigate(destination);
    }, 100);
  };

  const hideSideBar = () => {
    document.querySelector("#sidebar").classList.toggle("hide");
    document.querySelector("#sidebar").classList.toggle("show");
  };  

  return (
    <nav
      id="sidebar"
      className={isMobile ? "hide sidebarLayout" : "show sidebarLayout"}
    >
      <div>
        <div className="sidebar-header">
          <img
            src="/srmlogo.jpg"
            style={{ height: "100px", width: "100px" }}
            alt="Logo"
          />
        </div>
        <ul className="list-unstyled components menu-list">
          {modules.length > 0
          ? modules.map((module) => (
            <li
              key={module.id}
              className={activeModule === module.url ? "active" : ""}
            >
              <span
                className="custom-link-sidebar"
                onClick={() => navigatePage(module.url)}
              >
                <i className={`${module.icon} mx-2`}></i> {module.name}
              </span>
            </li>
          ))
          : <li key={1} className="active">
              <span
                className="custom-link-sidebar"
                // onClick={() => navigatePage(module.url)}
              >
                <i className="fa-solid fa-house mx-2"></i> Home
              </span>
            </li>
            }
        </ul>
      </div>
    </nav>
  );
};
export default Sidebar;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { isMobile } from "react-device-detect";
// import { useNavigate } from "react-router-dom";
// import SparkApi from "../../api/SparkApi";

// const Sidebar = () => {
//   const [modules, setModules] = useState([]);

//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchModuleData();
//   }, []);

//   async function fetchModuleData() {
//     try {
//       const data = await SparkApi.fetchModules();

//       const sortedModules = [...data.result].sort(
//         (a, b) => a.order_no - b.order_no
//       );
//       setModules(sortedModules);
//     } catch (error) {
//       setModules([]);
//     }
//   }

//   const navigatePage = (destination) => {
//     if (isMobile) hideSideBar();
//     setTimeout(() => {
//       navigate(destination);
//     }, 100);
//   };

//   const hideSideBar = () => {
//     document.querySelector("#sidebar").classList.toggle("hide");
//     document.querySelector("#sidebar").classList.toggle("show");
//   };

//   return (
//     <>
//       <nav
//         id="sidebar"
//         className={isMobile ? "hide sidebarLayout" : "show sidebarLayout"}
//       >
//         <div>
//           <div className="sidebar-header">
//             <img
//               src="/srmlogo.jpg"
//               style={{ height: "100px", width: "100px" }}
//               alt="Logo"
//             />
//           </div>

//           <ul className="list-unstyled components menu-list">
//             {modules.map((module) => (
//               <li
//                 key={module.id}
//                 className={`${
//                   location.pathname.includes(module.url) ? "active" : ""
//                 }`}
//               >
//                 <span
//                   className="custom-link-sidebar"
//                   onClick={() => navigatePage(module.url)}
//                 >
//                   <i className={`${module.icon} mx-2`}></i> {module.name}
//                 </span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </nav>
//     </>
//   );
// };
// export default Sidebar